module.exports = __webpack_public_path__ + "static/media/tianyi.52429964.jpg";